import { TFunction } from 'i18next';
import { ERROR_CODES } from 'models/ErrorCodes';
import { IPartnerFormFields } from 'modules/admin-panel/pages/partners/models';

import { LOGO_MAX_SIZE } from 'utils';

export const getPartnersFormInputName = (field: string): string => {
	if (field === 'contractDto.endDate') {
		return IPartnerFormFields.contractEndDate;
	}

	if (field === 'contractDto.startDate') {
		return IPartnerFormFields.contractStartDate;
	}

	return field;
};

export const getPartnersFormErrorMap = (t: TFunction) => {
	return {
		[ERROR_CODES.MISS_MATCH]: {
			[IPartnerFormFields.shortName]: t('invalid_symbols', {
				allowedSymbols: 'letters A-Z, upper-lower cases, integ. 0-9',
			}),
			[IPartnerFormFields.formalName]: t('invalid_symbols', {
				allowedSymbols:
					'letters A-Z, upper- lover cases, integ. 0-9, special char. &():;"',
			}),
			[IPartnerFormFields.website]: t('incorrect'),
			[IPartnerFormFields.comment]: t('invalid_symbols', {
				allowedSymbols:
					'A-Z, upper-lover cases, int. 0-9, special char ~!@#$%^&*_-+=`|(){}[]:;"\'<>,.?/ and spaсe',
			}),
		},
		[ERROR_CODES.INVALID_LENGTH]: {
			[IPartnerFormFields.shortName]: t('invalid_length'),
			[IPartnerFormFields.formalName]: t('invalid_length'),
			[IPartnerFormFields.website]: t('invalid_length'),
		},
		[ERROR_CODES.REQUIRED]: {
			[IPartnerFormFields.shortName]: t('required'),
			[IPartnerFormFields.formalName]: t('required'),
			[IPartnerFormFields.website]: t('required'),
			[IPartnerFormFields.logo]: t('required'),
			[IPartnerFormFields.surveyCountLimit]: t('required'),
			[IPartnerFormFields.clientCountLimit]: t('required'),
			[IPartnerFormFields.adminCountLimit]: t('required'),
			[IPartnerFormFields.partnerUserCountLimit]: t('required'),
			[IPartnerFormFields.contractEndDate]: t('required'),
			[IPartnerFormFields.surveyLimitPerClientDtos]: t('required'),
			[IPartnerFormFields.contractStartDate]: t('required'),
			[IPartnerFormFields.surveyCountLimit]: t('required'),
			[IPartnerFormFields.comment]: t('required'),
		},
		[ERROR_CODES.MAX_SIZE]: {
			[IPartnerFormFields.logo]: t('file_size_not_more', {
				size: LOGO_MAX_SIZE,
			}),
		},
		[ERROR_CODES.INVALID_FORMAT]: {
			[IPartnerFormFields.logo]: t('format_not_supported'),
		},
		[ERROR_CODES.PAST_DATE]: {
			[IPartnerFormFields.contractEndDate]: t('invalid_end_date'),
		},
		[ERROR_CODES.MIN_VALUE]: {
			[IPartnerFormFields.partnerUserCountLimit]: t('should_not_be_less', {
				minValue: 1,
			}),
			[IPartnerFormFields.adminCountLimit]: t('should_not_be_less', {
				minValue: 1,
			}),
		},
	};
};
